export const locales = ['zh-CN', 'en-US', 'zh-TW', 'ja', 'ko', 'fr', 'es', 'pt', 'de', 'it', 'ru', 'ar', 'th', 'vi', 'id', 'hi', 'nl', 'tr', 'pl'] as const;
export type Locale = (typeof locales)[number];

export const defaultLocale: Locale = 'zh-CN';

export const localeNames: Record<Locale, string> = {
  'zh-CN': '简体中文',
  'en-US': 'English',
  'zh-TW': '繁體中文',
  'ja': '日本語',
  'ko': '한국어',
  'fr': 'Français',
  'es': 'Español',
  'pt': 'Português',
  'de': 'Deutsch',
  'it': 'Italiano',
  'ru': 'Русский',
  'ar': 'العربية',
  'th': 'ภาษาไทย',
  'vi': 'Tiếng Việt',
  'id': 'Bahasa Indonesia',
  'hi': 'हिन्दी',
  'nl': 'Nederlands',
  'tr': 'Türkçe',
  'pl': 'Polski',
};

export const localeFlags: Record<Locale, string> = {
  'zh-CN': '🇨🇳',
  'en-US': '🇺🇸',
  'zh-TW': '🇭🇰',
  'ja': '🇯🇵',
  'ko': '🇰🇷',
  'fr': '🇫🇷',
  'es': '🇪🇸',
  'pt': '🇵🇹',
  'de': '🇩🇪',
  'it': '🇮🇹',
  'ru': '🇷🇺',
  'ar': '🇸🇦',
  'th': '🇹🇭',
  'vi': '🇻🇳',
  'id': '🇮🇩',
  'hi': '🇮🇳',
  'nl': '🇳🇱',
  'tr': '🇹🇷',
  'pl': '🇵🇱',
};

/**
 * 母语短写标签(1-2 字符,跨平台无 emoji 依赖)。用于紧凑触发器(如 guided 卡顶栏):
 * Windows/部分 Android 不渲染旗帜 emoji,故紧凑按钮用 Globe + 此短写;下拉仍用旗帜+全名。
 * CJK 用单字、拉丁系用 2 字母、其他文字用母语首字母。
 */
export const localeShortLabels: Record<Locale, string> = {
  'zh-CN': '中',
  'en-US': 'EN',
  'zh-TW': '繁',
  'ja': '日',
  'ko': '한',
  'fr': 'FR',
  'es': 'ES',
  'pt': 'PT',
  'de': 'DE',
  'it': 'IT',
  'ru': 'РУ',
  'ar': 'ع',
  'th': 'ไท',
  'vi': 'VI',
  'id': 'ID',
  'hi': 'हि',
  'nl': 'NL',
  'tr': 'TR',
  'pl': 'PL',
};

// Mapping from short locale codes (used in settings) or full locale codes (from API) to full locale codes (used in app)
export const shortToFullLocale: Record<string, Locale> = {
  'en': 'en-US',
  'zh': 'zh-CN',
  'en-US': 'en-US',
  'zh-CN': 'zh-CN',
  'zh-TW': 'zh-TW',
  'ja': 'ja',
  'ko': 'ko',
  'fr': 'fr',
  'es': 'es',
  'pt': 'pt',
  'de': 'de',
  'it': 'it',
  'ru': 'ru',
  'ar': 'ar',
  'th': 'th',
  'vi': 'vi',
  'id': 'id',
  'hi': 'hi',
  'nl': 'nl',
  'tr': 'tr',
  'pl': 'pl',
};

// Full locale codes (used in app) to short locale codes (legacy, for backwards compatibility)
export const fullToShortLocale: Record<Locale, string> = {
  'en-US': 'en-US',
  'zh-CN': 'zh-CN',
  'zh-TW': 'zh-TW',
  'ja': 'ja',
  'ko': 'ko',
  'fr': 'fr',
  'es': 'es',
  'pt': 'pt',
  'de': 'de',
  'it': 'it',
  'ru': 'ru',
  'ar': 'ar',
  'th': 'th',
  'vi': 'vi',
  'id': 'id',
  'hi': 'hi',
  'nl': 'nl',
  'tr': 'tr',
  'pl': 'pl',
};
